import { EntityStatusTypes } from "@enums/entity-status-types";
import { GenericAccountStateTypes } from "@enums/generic-account-state-types";

export const isNullOrUndefined = (value: any) => {
    return typeof value === "undefined" || value === null;
};

export const hasProperties = (object: Record<string, unknown>) => {
    return Object.keys(object).length > 0;
};

export const toObject = <T>(
    list: Array<any>,
    propertyName: string
): { [key: string]: T } => {
    return list.reduce((result, item) => {
        if(!propertyName){
            result[item] = item;
        } else {
            result[item[propertyName]] = item;
        }
       
        return result;
    }, {} as { [key: string]: T });
};

export const updateEntityStatus = <
    T extends { id: string; status: EntityStatusTypes },
    U extends { id: string; status: EntityStatusTypes }
>(
    list: Array<T>,
    newObject: U,
    accountState: GenericAccountStateTypes
) => {
    return list.reduce((newList, object) => {
        if (object.id === newObject.id) {
            if (accountState !== GenericAccountStateTypes.DELETE) {
                newList.push({
                    ...object,
                    status: newObject.status,
                });
            }
        } else {
            newList.push(object);
        }

        return newList;
    }, [] as Array<T>);
};
